import {ButtonPrimary} from '@homeaway/react-buttons';
import {compose} from 'redux';
import debounce from 'lodash.debounce';
import edap from '../edap';
import {ENTER_CHAR_CODE} from '../../../utils/constants';
import FormCharCounter, {isOverLimit} from '../../../components/form-char-counter/form-char-counter';
import {graphql} from 'react-apollo';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {log} from '../../../utils/logger';
import React, {Component} from 'react';
import {withAuth} from '../../../components/auth';
import {withUser} from '../../user/user';
import {withTranslationsAsProps} from '../../../components/translations';
import {
    ADD_NOTE,
    mutationProps
} from './comments-graphql';
import './add-comment.less';

export const logCharLimitError = debounce(log, 500, {
    leading: false,
    trailing: true
});

export const MAXLENGTH = 280;

export class AddComment extends Component {
    static defaultProps = {
        stopPolling: () => {}
    }

    static initialState = {
        disabled: false,
        error: null,
        loading: false,
        text: ''
    }

    constructor(props) {
        super(props);
        this.state = AddComment.initialState;
    }

    // hook for graphql
    onError = () => {
        /* istanbul ignore next */
        const {startPolling} = this.props;
        /* istanbul ignore next */
        this.setState({
            error: true,
            loading: false
        });
        /* istanbul ignore next */
        startPolling();
    }

    // hook for graphql
    onLoading = () => {
        /* istanbul ignore next */
        this.setState({loading: true});
    }

    // hook for graphql
    onSuccess = () => {
        /* istanbul ignore next */
        const {startPolling} = this.props;
        /* istanbul ignore next */
        this.reset();
        /* istanbul ignore next */
        startPolling();
    }

    reset = () => {
        /* istanbul ignore next */
        this.setState(AddComment.initialState);
    }

    submit = (e) => {
        const {addNote, boardId, endDate, listingId, startDate, stopPolling, user} = this.props;
        const role = user && user.role && user.role.type || '';
        const {disabled, text} = this.state;
        const {onError, onLoading, onSuccess} = this;
        e.preventDefault();
        if (disabled) {
            return;
        }
        stopPolling();
        edap.addComment(boardId, endDate, listingId, startDate, role);
        addNote({onError, onLoading, onSuccess, text});
    }

    onKeyPress = (e) => {
        /* istanbul ignore next */
        if (e.charCode === ENTER_CHAR_CODE) {
            this.submit(e);
        }
    }

    updateText = (e) => {
        /* istanbul ignore next */
        const text = e.target.value;
        const isOverCharLimit = isOverLimit(text, MAXLENGTH);

        this.setState({
            disabled: isOverCharLimit,
            text
        });

        // Log in splunk so we can see how often this is happening
        /* istanbul ignore next */
        if (isOverCharLimit) {
            logCharLimitError({message: `Comment exceeds character limit: ${text.length}`});
        }
    }

    render() {
        const {langAddComment, langError, langPost} = this.props;
        const {disabled, loading, error, text} = this.state;
        const isValid = !!text.length;
        const buttonClass = isValid ? 'is-valid' : '';
        const errorMsg = (error) ? langError : null;
        return (
            <form
                className="add-comment"
                id="add-comment-form"
                onSubmit={this.submit}
            >
                <LoadingOverlay loading={loading} />
                <FormCharCounter
                    autoExpand
                    className="add-comment__textarea"
                    errorMsg={errorMsg}
                    id="add-comment-input"
                    label={langAddComment}
                    maxHeight="169px"
                    maxLength={MAXLENGTH}
                    onChange={this.updateText}
                    onKeyPress={this.onKeyPress}
                    value={this.state.text}
                />
                <div className={`add-comment__buttons ${buttonClass}`}>
                    <ButtonPrimary
                        disabled={disabled}
                        label={langPost}
                        size="xs"
                        type="submit"
                    />
                </div>
            </form>
        );
    }
}

export default compose(
    withAuth,
    withUser,
    withTranslationsAsProps({
        'tripboards.add.comment': 'langAddComment',
        'tripboards.error': 'langError',
        'tripboards.post': 'langPost'
    }),
    graphql(ADD_NOTE, {props: mutationProps})
)(AddComment);



// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/components/add-comment.js